import { render, staticRenderFns } from "./ProductInterpretationsFlat.vue?vue&type=template&id=1e53e319&scoped=true&"
import script from "./ProductInterpretationsFlat.vue?vue&type=script&lang=js&"
export * from "./ProductInterpretationsFlat.vue?vue&type=script&lang=js&"
import style0 from "./ProductInterpretationsFlat.vue?vue&type=style&index=0&id=1e53e319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53e319",
  null
  
)

export default component.exports